// ============= Imports =============
import type { FC } from 'react';
import { PERMISSION_OVERWRITE_BANNER_TEXT } from '../../../utils/workflowTestingBypass';
import { Banner } from './PermissionOverwriteBanner.styles.ts';

// ============= Component =============

export const PermissionOverwriteBanner: FC = () => (
  <Banner role="alert" aria-live="polite">
    {PERMISSION_OVERWRITE_BANNER_TEXT}
  </Banner>
);
